import React from "react";
import { Navbar, Button } from "../";


export default function Header() {
    return (
        <header className="hero">
            <Navbar />
        </header>
    );
}
